import { createContext } from 'react';

import { TPrototypeDto } from '@app-velocity/av-api-v2';

export type ScenarioPageContextType = {
  shareToken: string;
  reviewId: string;
  scenario: TPrototypeDto;
  highlighted: boolean;
  toggleHighlight: () => void;
};

export const ScenarioPageContext = createContext<ScenarioPageContextType>({
  shareToken: '',
  reviewId: '',
  scenario: {},
  highlighted: false,
  toggleHighlight: () => null,
});
